import { useEffect, useState } from "react";
import css from "./AddQuestion.module.css";
import Modal from "../../../../../Components/Modal/Modal";
import AddQuestionForm from "./Form";
import Svg from "../../../../../Components/Svg/Svg";
import SvgOptions from "../../../../../Components/Svg/SvgOptions";

const Delete = ({ onDelete, onClose }) => {
	return (
		<div className={css.DeleteModalContainer}>
			<div className={css.DeleteModalContent}>
				<div className={css.InfoBadge}>
					<Svg className={css.Icon}>{SvgOptions.Info}</Svg>
				</div>
				<div>
					<h4 style={{ marginBottom: "10px" }}>Delete Question</h4>
					<p style={{ fontWeight: 300, lineHeight: 1.3 }}>
						You are about to permanently delete this question. This action
						cannot be undone.
					</p>
				</div>
			</div>
			<div className={css.BtnGroup} style={{ marginLeft: "300px" }}>
				<button onClick={onClose} className={`${css.CancelBtn} ${css.button}`} >
					Cancel
				</button>
				<button onClick={onDelete} className={`${css.DangerBtn} ${css.button}`}>
					Delete
				</button>
			</div>
		</div>
	);
};

const QuestionModal = ({
	isOpen,
	onClose,
	mode,
	question,
	updateQuestion,
	deleteQuestion,
}) => {
	const [local, setLocal] = useState(question);

	// useEffect(() => {
	//     if (question) setLocal(question);
	// }, [question]);

	useEffect(() => {
		if (isOpen && question) {
			setLocal(question);
		}
	}, [isOpen, question]);

	const titles = {
		view: "View",
		edit: "Edit",
		delete: "Delete",
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={`${titles[mode]} Risk Assessment Question`}
			size="md"
			className={`${css.ModalForm} ${mode === "delete" ? css.Delete : ""}`}
			centered={mode === "delete"}
		>
			{mode === "delete" ? (
				// <div>
				<Delete
					onDelete={() => {
						deleteQuestion(question.id);
						onClose();
					}}
					onClose={onClose}
				/>
			) : (
				<>
					{/* FORM */}
					<AddQuestionForm
						question={local}
						setQuestion={setLocal}
						readOnly={mode === "view"}
					/>

					{/* FOOTER BUTTONS */}
					{mode === "edit" && (
						<div className={`${css.ModalFooter} ${css.BtnGroup}`}>
							<button onClick={onClose} className={`${css.CancelBtn} ${css.button}`}>
								Cancel
							</button>
							<button
								onClick={() => {
									updateQuestion(local);
									onClose();
								}}
								className={`${css.PrimaryBtn} ${css.button}`}
							>
								Save Changes
							</button>
						</div>
					)}
				</>
			)}
		</Modal>
	);
};

export default QuestionModal;
